module.exports = __webpack_public_path__ + "img/excel.c867eb0f.png";